import script from "./WithdrawView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawView.vue?vue&type=script&lang=ts&setup=true"

import "./WithdrawView.vue?vue&type=style&index=0&id=88d6317e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88d6317e"]])

export default __exports__